import { Link, Navigate, useLocation } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";
import { money } from "../lib/cart";

export default function OrderReceived() {
  const order = useLocation().state?.order;
  if (!order) return <Navigate to="/shop" replace />;
  return (
    <div className="max-w-2xl mx-auto px-6 py-24 text-center" data-testid="order-received">
      <CheckCircle2 size={56} className="text-[#5E6B51] mx-auto mb-6" strokeWidth={1.5} />
      <h1 className="font-serif text-5xl mb-4">Order received</h1>
      <p className="font-mono text-lg text-[#5A433B]" data-testid="order-number">{order.order_number}</p>
      <p className="text-sm text-[#5E4D5A] mt-1">Total {money(order.total_cents || order.subtotal_cents)} {order.delivery_method === "meetup" ? "(Local Meetup, no shipping charge)" : `(includes ${money(order.shipping_cents || 0)} shipping)`} · Status: Awaiting Payment</p>
      {order.delivery_method === "meetup" && <p className="text-sm text-[#59394F] mt-2" data-testid="received-meetup-note">Meetup area: {order.meetup_area}. We'll text you to confirm a time and spot.</p>}
      <p className="text-[#5E4D5A] max-w-md mx-auto leading-relaxed mt-6">
        <strong className="text-[#5A433B]">Payment has not been collected.</strong> Our team will contact you at {order.customer_email} with payment details. Please don't send payment until you hear from us.
      </p>
      <Link to="/shop" className="inline-block mt-10 bg-[#59394F] text-white rounded-full px-8 py-4 text-sm hover:bg-[#432A3B] transition-colors">Keep browsing</Link>
    </div>
  );
}
